// frontend/src/components/layout/MainLayout/MainLayout.tsx

import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Sidebar } from '../Sidebar/Sidebar';
import { Header } from '../Header/Header';
import { NextStepCard } from '../NextStepCard/NextStepCard';
import './MainLayout.css';

export const MainLayout: React.FC = () => {
    const [isSidebarOpen, setIsSidebarOpen] = useState(true);

    const toggleSidebar = () => {
        setIsSidebarOpen(!isSidebarOpen);
    };

    return (
        <div className="main-layout">
            <Sidebar isOpen={isSidebarOpen} onToggle={toggleSidebar} />
            <div className={`main-content ${isSidebarOpen ? 'with-sidebar' : 'full-width'}`}>
                <Header onToggleSidebar={toggleSidebar} />
                <NextStepCard />
                <main className="page-content">
                    <Outlet />
                </main>
            </div>
        </div>
    );
};